import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    title: "どうぶつポチポチ",
    description: "画面内を一度クリックしてからキーボードを適当に叩いてください",
    animalCount: 0,
    animalList: [],
    currentNumInWindow: 0,
    animalLifetime: 30000, // ms
    modalText: 'キーを押すと動物が出現します。アルファベットに応じて異なる動物が出ます。',
    keyAnimalMap: {
      'a': ['alligator'],
      'b': ['bear'],
      'c': ['cat'],
      'd': ['duck'],
      'e': ['elephant'],
      'f': ['flamingo'],
      'g': ['giraffe', 'gorilla'],
      'h': ['horse'],
      'i': ['iguana'],
      'j': ['jaguar'],
      'k': ['koala'],
      'l': ['lama', 'lion'],
      'm': ['monkey'],
      'n': ['numbat'],
      'o': ['owl'],
      'p': ['penguin'],
      'q': ['quail'],
      'r': ['rhinoceros'],
      's': ['sheep'],
      't': ['tiger'],
      'u': ['unicorn'],
      'v': ['vampire_bat'],
      'w': ['whale'],
      'x': ['xerus'],
      'y': ['yak'],
      'z': ['zebra'],
      ' ': ['kamonohashi'],
      'other': ['animal_dog_osuwari'],
    },
  },
  mutations: {
    addAnimal (state, key) {
      if (key != null) {
        const newCount = state.animalCount + 1

        const map = state.keyAnimalMap
        const name = map[key] ? map[key][Math.floor(Math.random() * map[key].length)] : map["other"]

        const animal = {
          id: newCount,
          name: name
        }
        state.animalList.push(animal)
        state.animalCount = newCount
      }
    },
    removeAnimal (state) {
      state.animalList.shift()
    },
    incrementCurrentNum (state) {
      state.currentNumInWindow++;
    },
    decrementCurrentNum (state) {
      state.currentNumInWindow--;
    },
  },
  actions: {
    addAnimal ({ commit }, key) {
      commit('addAnimal', key)
    },
    removeAnimal ({ commit }, key) {
      commit('removeAnimal', key)
    },
    incrementCurrentNum ({ commit }) {
      commit('incrementCurrentNum')
    },
    decrementCurrentNum ({ commit }) {
      commit('decrementCurrentNum')
    },
  }
})
